import { pageInfo, detailInfo, editSubmit, deleteBatch, exportData, batchEditExport, exportReceiptZip, orderImport, warehouseShipImport, signingImport, receiptUpload, receiptUploadImport, mergeReceiptUpload, receiptFileList, deleteReceiptFile, delayReasonImport, batchEditImport, expressImport, downLoadTemplate, getForEdit, submitRowEdit, truckImport, transportCarrierImport } from './../api';
import { getCarrierList, getRouteList, getDeliveryLateCategoryList, getReceiptLateCategoryList } from '@/api/selects';
const track = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    detailInfoObj: null,
    editSubmitObj: null,
    deleteBatchObj: null,
    exportObj: null,
    batchEditExportObj: null,
    exportReceiptZipObj: null,
    orderImportObj: null,
    warehouseShipImportObj: null,
    signingImportObj: null,
    receiptUploadObj: null,
    receiptUploadImportObj: null,
    mergeReceiptUploadObj: null,
    receiptFileListObj: null,
    delayReasonImportObj: null,
    batchEditImportObj: null,
    expressImportObj: null,
    truckImportObj: null,
    transportCarrierImportObj: null,
    forEditObj: null,
    submitRowEditObj: null,
    carrierListObj: null,
    routeListObj: null,
    deliveryLateCategoryListObj: null,
    receiptLateCategoryListObj: null,
    templateObj: null
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => ({ ...item, btns: [true, true, true] }));
    },
    DETAIL_INFO(state, data) {
      state.detailInfoObj = data.obj || {};
    },
    EDIT_SUBMIT(state, data) {
      state.editSubmitObj = data;
    },
    DELETE_BATCH(state, data) {
      state.deleteBatchObj = data;
    },
    EXPORT_DATA(state, data) {
      state.exportObj = data;
    },
    BATCH_EDIT_EXPORT(state, data) {
      state.batchEditExportObj = data;
    },
    EXPORT_RECEIPT_ZIP(state, data) {
      state.exportReceiptZipObj = data;
    },
    ORDER_IMPORT(state, data) {
      state.orderImportObj = data;
    },
    WAREHOUSE_SHIP_IMPORT(state, data) {
      state.warehouseShipImportObj = data;
    },
    SIGNING_IMPORT(state, data) {
      state.signingImportObj = data;
    },
    RECEIPT_UPLOAD(state, data) {
      state.receiptUploadObj = data;
    },
    RECEIPT_UPLOAD_IMPORT(state, data) {
      state.receiptUploadImportObj = data;
    },
    MERGE_RECEIPT_UPLOAD(state, data) {
      state.mergeReceiptUploadObj = data;
    },
    RECEIPT_FILE_LIST(state, data) {
      state.receiptFileListObj = data;
    },
    DELAY_REASON_IMPORT(state, data) {
      state.delayReasonImportObj = data;
    },
    BATCH_EDIT_IMPORT(state, data) {
      state.batchEditImportObj = data;
    },
    EXPRESS_IMPORT(state, data) {
      state.expressImportObj = data;
    },
    TRUCK_IMPORT(state, data) {
      state.truckImportObj = data;
    },
    TRANSPORT_CARRIER_IMPORT(state, data) {
      state.transportCarrierImportObj = data;
    },
    FOR_EDIT(state, data) {
      state.forEditObj = data;
    },
    SUBMIT_ROW_EDIT(state, data) {
      state.submitRowEditObj = data;
    },
    SELECT_CARRIER_LIST(state, data) {
      state.carrierListObj = data;
    },
    SELECT_ROUTE_LIST(state, data) {
      state.routeListObj = data;
    },
    SELECT_DELIVERY_LATE_CATEGORY_LIST(state, data) {
      state.deliveryLateCategoryListObj = data;
    },
    SELECT_RECEIPT_LATE_CATEGORY_LIST(state, data) {
      state.receiptLateCategoryListObj = data;
    },
    DOWN_TEMPLATE(state, data) {
      state.templateObj = data;
    }
  },
  actions: {
    async pageInfo({ commit }, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async detailInfo({ commit }, obj) {
      let resp = await detailInfo(obj);
      commit('DETAIL_INFO', resp);
    },
    async editSubmit({ commit }, obj) {
      let resp = await editSubmit(obj);
      commit('EDIT_SUBMIT', resp);
    },
    async deleteBatch({ commit }, obj) {
      let resp = await deleteBatch(obj);
      commit('DELETE_BATCH', resp);
    },
    async exportData({ commit }, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
    async batchEditExport({ commit }, obj) {
      let resp = await batchEditExport(obj);
      commit('BATCH_EDIT_EXPORT', resp);
    },
    async exportReceiptZip({ commit }, obj) {
      let resp = await exportReceiptZip(obj);
      commit('EXPORT_RECEIPT_ZIP', resp);
      return resp;
    },
    async orderImport({ commit }, obj) {
      let resp = await orderImport(obj);
      commit('ORDER_IMPORT', resp);
    },
    async warehouseShipImport({ commit }, obj) {
      let resp = await warehouseShipImport(obj);
      commit('WAREHOUSE_SHIP_IMPORT', resp);
    },
    async signingImport({ commit }, obj) {
      let resp = await signingImport(obj);
      commit('SIGNING_IMPORT', resp);
    },
    async receiptUpload({ commit }, obj) {
      let resp = await receiptUpload(obj);
      commit('RECEIPT_UPLOAD', resp);
    },
    async receiptUploadImport({ commit }, obj) {
      let resp = await receiptUploadImport(obj);
      commit('RECEIPT_UPLOAD_IMPORT', resp);
      return resp;
    },
    async mergeReceiptUpload({ commit }, obj) {
      let resp = await mergeReceiptUpload(obj);
      commit('MERGE_RECEIPT_UPLOAD', resp);
      return resp;
    },
    async receiptFileList({ commit }, obj) {
      let resp = await receiptFileList(obj);
      commit('RECEIPT_FILE_LIST', resp);
      return resp;
    },
    async deleteReceiptFile({ commit }, obj) {
      return await deleteReceiptFile(obj);
    },
    async delayReasonImport({ commit }, obj) {
      let resp = await delayReasonImport(obj);
      commit('DELAY_REASON_IMPORT', resp);
    },
    async batchEditImport({ commit }, obj) {
      let resp = await batchEditImport(obj);
      commit('BATCH_EDIT_IMPORT', resp);
    },
    async expressImport({ commit }, obj) {
      let resp = await expressImport(obj);
      commit('EXPRESS_IMPORT', resp);
    },
    async getForEdit({ commit }, obj) {
      let resp = await getForEdit(obj);
      commit('FOR_EDIT', resp);
      return resp;
    },
    async submitRowEdit({ commit }, obj) {
      let resp = await submitRowEdit(obj);
      commit('SUBMIT_ROW_EDIT', resp);
      return resp;
    },
    async truckImport({ commit }, obj) {
      let resp = await truckImport(obj);
      commit('TRUCK_IMPORT', resp);
      return resp;
    },
    async transportCarrierImport({ commit }, obj) {
      let resp = await transportCarrierImport(obj);
      commit('TRANSPORT_CARRIER_IMPORT', resp);
      return resp;
    },
    async selectCarrierList({ commit }, obj) {
      let resp = await getCarrierList(obj);
      commit('SELECT_CARRIER_LIST', resp);
      return resp;
    },
    async selectRouteList({ commit }, obj) {
      let resp = await getRouteList(obj);
      commit('SELECT_ROUTE_LIST', resp);
      return resp;
    },
    async selectDeliveryLateCategoryList({ commit }, obj) {
      let resp = await getDeliveryLateCategoryList(obj);
      commit('SELECT_DELIVERY_LATE_CATEGORY_LIST', resp);
      return resp;
    },
    async selectReceiptLateCategoryList({ commit }, obj) {
      let resp = await getReceiptLateCategoryList(obj);
      commit('SELECT_RECEIPT_LATE_CATEGORY_LIST', resp);
      return resp;
    },
    async downLoadTemplate({ commit }, obj) {
      let resp = await downLoadTemplate(obj);
      commit('DOWN_TEMPLATE', resp);
    }
  }
}
export default track



// WEBPACK FOOTER //
// ./src/page/track/store/track.store.js